var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["modal/modal-contents.j2"] = require( "modal/modal-contents.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/wishlist/wishlist-moved.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("modal/modal-contents.j2", true, "product/templates/wishlist/wishlist-moved.j2", false, function(t_2,_parentTemplate) {
if(t_2) { cb(t_2); return; }
parentTemplate = _parentTemplate
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n\n";
env.getTemplate("macros/urls.j2", false, "product/templates/wishlist/wishlist-moved.j2", false, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
t_3.getExported(function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
if(t_3.hasOwnProperty("wishlistUrl")) {
var t_6 = t_3.wishlistUrl;
} else {
cb(new Error("cannot import 'wishlistUrl'")); return;
}
context.setVariable("wishlistUrl", t_6);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_styles"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modal_contents"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_styles(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modal_contents(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\n\n    <div class=\"o-row u-centered-content\">\n\n        <div class=\"o-column o-extra-small--12\">\n\n            <p class=\"c-wishlist-modal-move__confirmation--header\">\n\n                ";
output += runtime.suppressValue((lineno = 15, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["wishlist_move-confirmation"])), env.opts.autoescape);
output += "\n\n            </p>\n\n            <p class=\"c-wishlist-modal-move__confirmation--name\">\n\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "wishlistName"), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n    <div class=\"o-row u-centered-content\">\n\n        <div class=\"o-column o-extra-small--12 o-small--8 o-medium--6 o-extra-small--centered\">\n\n            <a href=\"";
output += runtime.suppressValue((lineno = 33, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "wishlistUrl"), "wishlistUrl", context, [runtime.contextOrFrameLookup(context, frame, "wishlistId"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\"\n                class=\"c-wishlist-modal-move__confirmation--button c-button-primary\"\n                ";
output += runtime.suppressValue((lineno = 35, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 35, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"move item","view in list"])), env.opts.autoescape);
output += ">\n\n                ";
output += runtime.suppressValue((lineno = 37, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["wishlist_move-confirmation-button"])), env.opts.autoescape);
output += "\n\n            </a>\n\n        </div>\n\n    </div>\n\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_modal_styles: b_modal_styles,
b_modal_contents: b_modal_contents,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/wishlist/wishlist-moved.j2"] , dependencies)